"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapRadiusSearch = void 0;
const basic_1 = require("../basic");
const colors_1 = require("../basic/colors");
exports.mapRadiusSearch = (0, basic_1.applyBase)({
    autocompleteControls: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'absolute',
        top: '10px',
        left: '10px',
        pointerEvents: 'auto',
    },
    radiusInput: {
        marginLeft: '-1px',
        '.input': {
            height: '50px',
        },
    },
    pin: {
        '.map-pin-content': {
            backgroundColor: colors_1.colors.bgDarkBlueSecond,
        },
        '.map-pin-wrapper:after': {
            borderTopColor: colors_1.colors.bgDarkBlueSecond,
        },
    },
    locationIcon: {
        display: 'inline-block',
        pr: 2,
        my: -4,
    },
});
//# sourceMappingURL=map-radius-search.js.map